export function resolveTimezone(): string {
  const dateTimeFormat = window.Intl?.DateTimeFormat;
  if (dateTimeFormat) {
    const timezone = new dateTimeFormat().resolvedOptions().timeZone;
    if (timezone) return timezone;
  }
  const offset = -resolveTimezoneOffsetMinutes();
  return `UTC${offset >= 0 ? '+' : ''}${Math.abs(offset)}`;
}

export function resolveLocale(): string | null {
  return Intl.DateTimeFormat().resolvedOptions().locale ?? null;
}

export function resolveDocumentVisibility(): string {
  return document.visibilityState;
}

export interface UserAgentDataInfo {
  brands: string | null;
  mobile: boolean | null;
  platform: string | null;
}

export function readUserAgentData(): UserAgentDataInfo {
  const data = (navigator as any).userAgentData;
  if (!data) return {brands: null, mobile: null, platform: null};
  const brands = Array.isArray(data.brands)
    ? data.brands.map((b: any) => `${b.brand};${b.version}`).join('|')
    : null;
  return {
    brands,
    mobile: typeof data.mobile === 'boolean' ? data.mobile : null,
    platform: typeof data.platform === 'string' ? data.platform : null,
  };
}

export interface MediaPreferences {
  prefersColorScheme: string;
  prefersReducedMotion: boolean;
  prefersContrast: string;
  forcedColors: string;
}

export function readMediaPreferences(): MediaPreferences {
  return {
    prefersColorScheme: matchAny(['(prefers-color-scheme: dark)', 'dark'], ['(prefers-color-scheme: light)', 'light']),
    prefersReducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    prefersContrast: matchAny(
      ['(prefers-contrast: more)', 'more'],
      ['(prefers-contrast: less)', 'less'],
      ['(prefers-contrast: no-preference)', 'no-preference'],
    ),
    forcedColors: window.matchMedia('(forced-colors: active)').matches ? 'active' : 'none',
  };
}

function matchAny(...candidates: [string, string][]): string {
  for (const [query, value] of candidates) {
    if (window.matchMedia && window.matchMedia(query).matches) return value;
  }
  return 'no-preference';
}

function resolveTimezoneOffsetMinutes(): number {
  const year = new Date().getFullYear();
  return Math.max(
    new Date(year, 0, 1).getTimezoneOffset(),
    new Date(year, 6, 1).getTimezoneOffset(),
  );
}
